import { useQuery } from "@tanstack/react-query";
import * as services from "../services/services";

export const useInventoryQueries = (activeTab) => {
  // 1. Fetch data for the active tab
  const dataQuery = useQuery({
    queryKey: ["inventory-settings", "table", activeTab],
    queryFn: () => services.getInventorySettings({ settingType: activeTab, limit: 10000 }),
    select: (res) => res.data?.data || res.data || [],
    staleTime: 60000,
  });

  // 2. Fetch dropdown data (Categories, Brands, Units, Stores, Registered Types, Vendors)
  const dropdownQueries = {
    categories: useQuery({
      queryKey: ["inventory-settings", "dropdown", "category"],
      queryFn: () => services.getInventorySettings({ settingType: "category", status: "ACTIVE", limit: 10000 }),
      select: (res) => (res.data?.data || res.data || []).map(c => ({ 
        ...c, 
        label: c.categoryCode ? `${c.categoryName} (${c.categoryCode})` : c.categoryName || c.title 
      })),
      staleTime: 5 * 60000,
    }),
    subCategories: useQuery({
      queryKey: ["inventory-settings", "dropdown", "subCategory"],
      queryFn: () => services.getInventorySettings({ settingType: "subCategory", status: "ACTIVE", limit: 10000 }),
      select: (res) => (res.data?.data || res.data || []).map(sc => ({ 
        ...sc, 
        label: sc.subCategoryCode ? `${sc.subCategoryName} (${sc.subCategoryCode})` : sc.subCategoryName || sc.title 
      })),
      staleTime: 5 * 60000,
    }),
    brands: useQuery({
      queryKey: ["inventory-settings", "dropdown", "brand"],
      queryFn: () => services.getInventorySettings({ settingType: "brand", status: "ACTIVE", limit: 10000 }),
      select: (res) => (res.data?.data || res.data || []).map(b => ({ 
        ...b, 
        label: b.brandCode ? `${b.brandName} (${b.brandCode})` : b.brandName || b.title 
      })),
      staleTime: 5 * 60000,
    }),
    units: useQuery({
      queryKey: ["inventory-settings", "dropdown", "unit"],
      queryFn: () => services.getInventorySettings({ settingType: "unit", status: "ACTIVE", limit: 10000 }),
      select: (res) => (res.data?.data || res.data || []).map(u => ({ 
        ...u, 
        label: u.unitCode ? `${u.unitName} (${u.unitCode})` : u.unitName || u.title 
      })),
      staleTime: 5 * 60000,
    }),
    stores: useQuery({
      queryKey: ["inventory-settings", "dropdown", "stores"],
      queryFn: () => services.getInventorySettings({ settingType: "stores", status: "ACTIVE", limit: 10000 }),
      select: (res) => (res.data?.data || res.data || []).map(s => ({ 
        ...s, 
        label: s.storeCode ? `${s.storeName} (${s.storeCode})` : s.storeName || s.title 
      })),
      staleTime: 5 * 60000,
    }),
    registeredTypes: useQuery({
      queryKey: ["inventory-settings", "dropdown", "registeredType"],
      queryFn: () => services.getInventorySettings({ settingType: "registeredType", status: "ACTIVE", limit: 10000 }),
      select: (res) => (res.data?.data || res.data || []).map(rt => ({ 
        ...rt, 
        label: rt.registeredTypeCode ? `${rt.registeredTypeName} (${rt.registeredTypeCode})` : rt.registeredTypeName || rt.title 
      })),
      staleTime: 5 * 60000,
    }),
    vendors: useQuery({
      queryKey: ["inventory-settings", "dropdown", "vendor"],
      queryFn: () => services.getInventorySettings({ settingType: "vendor", status: "ACTIVE", limit: 10000 }),
      select: (res) => (res.data?.data || res.data || []).map(v => ({ ...v, label: v.vendorCode ? `${v.vendorName} (${v.vendorCode})` : v.vendorName || v.name || v.title })),
      staleTime: 5 * 60000,
    }),
  };
// console.log("dropdownQueries", registeredTypes);
  return {
    data: dataQuery.data || [],
    isLoading: dataQuery.isLoading,
    isRefetching: dataQuery.isRefetching,
    refetch: dataQuery.refetch,
    dropdowns: {
      categories: dropdownQueries.categories.data || [],
      subCategories: dropdownQueries.subCategories.data || [],
      brands: dropdownQueries.brands.data || [],
      units: dropdownQueries.units.data || [],
      stores: dropdownQueries.stores.data || [],
      registeredTypes: dropdownQueries.registeredTypes.data || [],
      vendors: dropdownQueries.vendors.data || [],
    },
    isDropdownsLoading: Object.values(dropdownQueries).some(q => q.isLoading),
  };
};
